import root from 'window-or-global';

export const getElementById = id => root.document.getElementById(id);
